export default __webpack_public_path__ + "static/media/postgresql_color.29aef667.svg";